import { ONE } from '../../../constans/common-constants';

enum ShowMode {
    Begin = 'begin',
    Middle = 'middle',
    End = 'end'
}

const pagesCalculator = (pagesLength: number, currentPage: number): (string | number)[] => {
  let numbersOfPages = [];
  const TWO = 2;
  const numberOfVisiblePages = 3;
  const endPointForMiddleTransition = pagesLength - numberOfVisiblePages + ONE;

    // maximum pages without 3dots
  const startShow = 5;

  const pagesPosition = (mode: ShowMode) => {
    const result = [];
    const middleStartIteration = currentPage - Math.floor(numberOfVisiblePages / TWO);
    const middleLimitIteration = currentPage + Math.floor(numberOfVisiblePages / TWO);

    switch (mode) {
      case ShowMode.Begin:
        for (let i = ONE; i <= numberOfVisiblePages; i++) {
          result.push(i);
        }
        break;
      case ShowMode.Middle:
        for (let i = middleStartIteration; i <= middleLimitIteration; i++) {
          result.push(i);
        }
        break;
      case ShowMode.End:
        for (let i = endPointForMiddleTransition; i <= pagesLength; i++) {
          result.push(i);
        }
    }

    return result;
  };

  if (pagesLength >= ONE && pagesLength <= startShow) {
    for (let i = ONE; i <= pagesLength; i++) {
      numbersOfPages.push(i);
    }
  } else if (currentPage < numberOfVisiblePages) {
    numbersOfPages = [...pagesPosition(ShowMode.Begin), '...', pagesLength];
  } else if (currentPage >= numberOfVisiblePages && currentPage <= endPointForMiddleTransition) {
    numbersOfPages = [ONE, '...', ...pagesPosition(ShowMode.Middle), '...', pagesLength];
  } else {
    numbersOfPages = [ONE, '...', ...pagesPosition(ShowMode.End)];
  }

  return numbersOfPages;
};

export { pagesCalculator };